module.exports = __webpack_public_path__ + "img/collectif-auth-certificate-bg.0ce13163.png";